import type { Text } from '@compass/client/types/text';
import { Button } from '@components/ui/button';
import { Copy } from 'lucide-react';
import React from 'react';

import { FormattedDateTime } from '@/components/FormattedDateTime';
import { getTextStatusDisplayText } from '@/utils/callsTabs/statusDisplay';
import { copyToClipboard } from '@/utils/clipboard';

import type { PopoverContentProps, TabLabelContext, TabTypeHandler } from './types';

const getLabel = (_data: Text, _context: TabLabelContext): string => {
  return 'Text';
};

const TextPopoverContent: React.FC<PopoverContentProps<Text>> = ({ data: textMessage }) => {
  return (
    <div className="space-y-2 text-sm">
      <div className="flex justify-between gap-8 items-center">
        <span className="text-muted-foreground">Text ID:</span>
        <div className="flex items-center gap-2">
          <span className="font-mono text-xs">{textMessage.id}</span>
          {textMessage.id && (
            <Button
              variant="outline"
              size="sm"
              onClick={() => copyToClipboard(textMessage.id!)}
              className="h-6 w-6 p-0"
            >
              <Copy className="w-3 h-3" />
            </Button>
          )}
        </div>
      </div>
      <div className="flex justify-between gap-8">
        <span className="text-muted-foreground">Type:</span>
        <span>Text Message</span>
      </div>
      <div className="flex justify-between gap-8">
        <span className="text-muted-foreground">Status:</span>
        <span>{getTextStatusDisplayText(textMessage.status)}</span>
      </div>
      {textMessage.to && (
        <div className="flex justify-between gap-8">
          <span className="text-muted-foreground">To:</span>
          <span>{textMessage.to}</span>
        </div>
      )}
      {textMessage.content && (
        <div className="">
          <div className="bg-secondary p-2 rounded text-xs">
            <div className="text-muted-foreground mb-1">Content:</div>
            <div className="text-foreground whitespace-pre-wrap max-w-[400px] max-h-20 overflow-auto">
              {textMessage.content}
            </div>
          </div>
        </div>
      )}
      {textMessage.error && (
        <div className="flex justify-between gap-8">
          <span className="text-muted-foreground">Error:</span>
          <span className="text-destructive">{textMessage.error}</span>
        </div>
      )}
      {textMessage.created_at && (
        <div className="flex justify-between gap-8">
          <span className="text-muted-foreground">Created:</span>
          <FormattedDateTime value={textMessage.created_at} />
        </div>
      )}
    </div>
  );
};

export const textHandler: TabTypeHandler<Text> = {
  isDisabled: true,
  getLabel,
  getStatusLabel: data => getTextStatusDisplayText(data.status),
  PopoverContent: TextPopoverContent,
};
